
import ActionMixins from '@/pagemixins/map/id';
export default {
  mixins: [ActionMixins],
  layout: 'm_index'
}
